import { Select, Form } from 'antd'
import i18n from 'i18next'
import React, { useEffect, useState } from 'react'
import { get } from '../../api/auth'
import { getEnumerationUrl } from '../../api/consts'
import { useAuth } from '../../context/AuthProvider'

const Enumeration = ({ name, inputName, placeholder }) => {
  const [loading, setLoading] = useState(true)
  const [options, setOptions] = useState([])
  const { token, apiHost } = useAuth()

  useEffect(() => {
    getEnumerations((result) => {
      if (result) {
        setOptions(
          Object.keys(result).map((key) => {
            return {
              value: key,
              label: result[key],
            }
          })
        )
        setLoading(false)
      }
    })
  }, [])
  const getEnumerations = async (onSuccess) => {
    const result = await get(
      getEnumerationUrl(apiHost, i18n.resolvedLanguage, name),
      token
    )
    if (result.ok === false || result['error']) {
      // displayError(result.statusText)
    } else {
      onSuccess(result[name])
    }
  }
  return (
    <Form.Item name={inputName} noStyle>
      <Select placeholder={placeholder} loading={loading} options={options} />
    </Form.Item>
  )
}

export default Enumeration
